import React, { useState } from 'react';

import CryptoJS from 'crypto-js';

const secretKey = 'MetaKAT3D-view*&^%$#@!(Book)';

export const encyptedData = (data) => {
    return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
};

export const decryptedData = (data) => {
    const dataconvert = CryptoJS.AES.decrypt(
        data, 
        secretKey
    );
    console.log(dataconvert,"decryptedData");
    console.log(dataconvert.toString(),"decryptedData");
    // console.log(dataconvert.toString(CryptoJS.enc.Utf8),"decryptedData");
    try {
        if(dataconvert.toString() !== ""){
            return JSON.parse(dataconvert.toString(CryptoJS.enc.Utf8))
        } else {
            return ''
        }
    } catch (error) {
        console.error("Decryption failed or result is not valid JSON");
    }
    
};

